export default __webpack_public_path__ + "static/media/released-but-not-bookable.6af89078.svg";